import dev from 'config/dev.json';
import local from 'config/local.json';
import prod from 'config/prod.json';
import uat from 'config/uat.json';

const envConfig = ((): { readonly enableBusinessUnits?: boolean } => {
  switch (process.env.REACT_APP_BUILD_ENV) {
    case 'dev':
      return dev;
    case 'uat':
      return uat;
    case 'prod':
      return prod;
    default:
      return local;
  }
})();

export const isBusinessUnitsEnabled = envConfig.enableBusinessUnits === true;
